import format from "lib/format";
import { urlStateService } from "./services/urlStateService";

export const getCardImage = (image) => {
  return image && format.url(`${image}`);
};

/**
 * Formats duration object to string format (HH:MM)
 * @param {Object} duration - Duration object with hours and minutes
 * @param {number} duration.hours - Number of hours
 * @param {number} duration.minutes - Number of minutes
 * @returns {string} Formatted duration string
 */
export const formatDuration = (duration) => {
  if (!duration) return "";
  const { hours, minutes } = duration;
  return `${hours}:${minutes.toString().padStart(2, "0")}`;
};

/**
 * Appends query parameters to a URL
 * @param {string} url - Base URL (may already contain query parameters)
 * @param {string} queryString - Query string to append (e.g., "c1=7&view=card")
 * @returns {string} URL with appended query parameters
 */
export const appendQueryParams = (url, queryString) => {
  if (!queryString || queryString.trim() === "") {
    return url || "";
  }

  if (!url) {
    return `?${queryString}`;
  }

  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}${queryString}`;
};

/**
 * Gets the read more link with catalogue filter query parameters appended
 * @param {Object} params - Parameters object
 * @param {string} params.learningActivityUrl - Internal learning activity URL
 * @param {string} params.learningActivityExternalUrl - External learning activity URL
 * @param {boolean} params.isPublic - Whether to use external URL
 * @param {Object} params.filters - Current filter state
 * @param {Object} params.uiState - Current UI state
 * @returns {string} URL with appended catalogue filter query parameters
 */
export const getReadMoreLink = ({
  learningActivityUrl,
  learningActivityExternalUrl,
  isPublic = false,
  filters,
  uiState,
}) => {
  let readMoreLink = isPublic
    ? learningActivityExternalUrl
    : learningActivityUrl;

  // Ensure we have a valid URL string (default to empty string if undefined)
  if (!readMoreLink) {
    readMoreLink = "";
  }

  if (filters && uiState) {
    const catalogueQueryParams = urlStateService.serializeStateToQuery(
      filters,
      uiState,
    );

    if (catalogueQueryParams) {
      readMoreLink = appendQueryParams(readMoreLink, catalogueQueryParams);
    }
  }

  return readMoreLink;
};
